import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCup"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3.5C3 3.22386 3.22386 3 3.5 3H16.5C16.7761 3 17 3.22386 17 3.5V6H18.5C19.8807 6 21 7.11929 21 8.5V10.5C21 11.8807 19.8807 13 18.5 13H17V18.5C17 19.8807 15.8807 21 14.5 21H5.5C4.11929 21 3 19.8807 3 18.5V3.5ZM17 12H18.5C19.3284 12 20 11.3284 20 10.5V8.5C20 7.67157 19.3284 7 18.5 7H17V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCup;
